import type { OtpRequestResponse, OtpVerifyResponse } from '@m8-app/contracts/rest/auth.js';
import { backendClient } from './client.js';

// Login is unavoidably a backend call — only the backend owns user identity
// (OTP, users, admin_roles). Device Plane data itself comes from the
// middleware directly; see devicePlane.ts.

export async function requestOtp(mobileNumber: string): Promise<OtpRequestResponse> {
  const { data } = await backendClient.post<OtpRequestResponse>('/auth/otp/request', { mobileNumber });
  return data;
}

export async function verifyOtp(mobileNumber: string, otp: string): Promise<OtpVerifyResponse> {
  const { data } = await backendClient.post<OtpVerifyResponse>('/auth/otp/verify', { mobileNumber, otp });
  return data;
}

export async function logout(refreshToken: string): Promise<void> {
  await backendClient.post('/auth/logout', { refreshToken });
}
